/**
 * To help color text inside dynamically colored containers
 * @param  {String} colour string containing hex of the form `#FFFFFF`
 * @return {String}        black or white
 */
const contrast = (colour) => {
  const hexcolor = colour.replace('#', '');
  const r = parseInt(hexcolor.substr(0, 2), 16);
  const g = parseInt(hexcolor.substr(2, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);
  const yiq = ((r*299)+(g*587)+(b*114))/1000;

  return (yiq >= 128) ? 'black' : 'white';
};

export default contrast;
